import Cookies from 'js-cookie';

// Shared with the TypeScript apps (@folq/components leftSidebarMenuCookie.ts); keep name and attributes in sync.
const COOKIE_NAME = 'folq_left_sidebar_menu';
const LEGACY_LOCAL_STORAGE_KEY = 'leftSidebarMenu';

const cookieDomain = (hostname) =>
  hostname === 'folq.com' || hostname.endsWith('.folq.com') ? '.folq.com' : undefined;

export const isLeftSidebarMenuKey = (key) => key === LEGACY_LOCAL_STORAGE_KEY;

export const readLeftSidebarMenuState = () =>
  Cookies.get(COOKIE_NAME) ?? localStorage.getItem(LEGACY_LOCAL_STORAGE_KEY);

export const writeLeftSidebarMenuState = (value) => {
  Cookies.set(COOKIE_NAME, value, {
    expires: 365,
    path: '/',
    sameSite: 'Lax',
    domain: cookieDomain(window.location.hostname),
    secure: window.location.protocol === 'https:',
  });
};
